// Things bank SMS show that the app doesn't know about yet, to ask the person about:
//   card:       a credit card (by its last 4 digits) that isn't in the Cards section
//   salary:     a salary coming in, with no repeating salary under Income
//   investment: a SIP / mutual fund / other investment payment with no investment of
//               that name on Finances (or one that isn't set to repeat)
// Nothing is added until the person says yes. What they turn down is remembered on
// this phone and not asked again.

const DISMISSED_KEY = "budgetsprint-sms-discovery-dismissed";

const readDismissed = () => {
  try {
    return new Set(JSON.parse(localStorage.getItem(DISMISSED_KEY) || "[]"));
  } catch {
    return new Set();
  }
};
export const dismissDiscovery = (id) => {
  const set = readDismissed();
  set.add(id);
  try {
    localStorage.setItem(DISMISSED_KEY, JSON.stringify([...set].slice(-500)));
  } catch {
    // ignore
  }
};

const same = (a, b) => String(a || "").trim().toLowerCase() === String(b || "").trim().toLowerCase();
const newestFirst = (list) => [...list].sort((a, b) => (a.date < b.date ? 1 : -1));

// `entries` are parsed messages (parseBankSms plus their key), old and new;
// `data` is what the app has (useMobileData).
export const findDiscoveries = (entries, data) => {
  const dismissed = readDismissed();
  const found = [];

  // Cards: grouped by their digits; the newest message gives the bank's name.
  const cards = new Map();
  for (const e of newestFirst(entries)) {
    if (e.via !== "card" || !e.digits || e.kind === "income") continue;
    if (!cards.has(e.digits)) cards.set(e.digits, { bank: e.bank, keys: [] });
    cards.get(e.digits).keys.push(e.key);
  }
  for (const [digits, c] of cards) {
    const id = `card:${digits}`;
    if (dismissed.has(id) || data.cards.some((x) => x.last4 === digits)) continue;
    found.push({ id, kind: "card", last4: digits, name: `${c.bank || "Credit"} card`, keys: c.keys });
  }

  // Salary: the newest one, if there isn't a repeating salary already.
  const hasSalary = data.income.some((i) => i.type === "Salary" && i.repeatUnit && i.repeatUnit !== "once");
  const salary = newestFirst(entries).find((e) => e.kind === "income" && e.type === "Salary");
  if (salary && !hasSalary && !dismissed.has(`salary:${salary.payee.toLowerCase()}`)) {
    found.push({ id: `salary:${salary.payee.toLowerCase()}`, kind: "salary", source: salary.payee, amount: salary.amount, date: salary.date, digits: salary.via === "account" ? salary.digits : null });
  }

  // Investments: by name; the newest payment gives the amount and date.
  const investments = new Map();
  for (const e of newestFirst(entries)) {
    if (e.kind !== "expense" || e.type !== "Investments") continue;
    const name = e.payee.toLowerCase();
    if (!investments.has(name)) investments.set(name, { name: e.payee, amount: e.amount, date: e.date, keys: [], total: 0 });
    const inv = investments.get(name);
    inv.keys.push(e.key);
    inv.total += e.amount;
  }
  for (const [name, inv] of investments) {
    const id = `investment:${name}`;
    const existing = data.assets.find((a) => a.category === "investment" && same(a.name, inv.name));
    if (dismissed.has(id) || (existing && existing.repeatUnit !== "once")) continue;
    found.push({ id, kind: "investment", ...inv, existing: existing || null });
  }
  return found;
};
